<div class="input-group">
  @if (symbolPosition === 'START') {
    <div class="input-group-text">
      {{ symbol }}
    </div>
  }
  <input
    type="number"
    class="form-control text-end"
    [class.is-invalid]="showError"
    [class.rounded-end]="symbolPosition !== 'END'"
    [(ngModel)]="model"
    [min]="min"
    [max]="max"
    [disabled]="disabled"
    (ngModelChange)="onChange($event)"
    (blur)="onTouched()"
  />
  @if (symbolPosition === 'END') {
    <div class="input-group-text rounded-end">
      {{ symbol }}
    </div>
  }
  <ng-content></ng-content>
</div>
